/**
 * Allys Project Card
 * 
 * Theme-specific implementation using the new MagazineBannerCard
 * for a stunning editorial, magazine-cover aesthetic.
 */

'use client';

import React from 'react';
import { MagazineBannerCard, type MagazineBannerCardProps } from '../../../../src/components/projects';

export type AllysProjectCardProps = Omit<MagazineBannerCardProps, 'variant'> & {
  variant?: 'default' | 'featured' | 'compact';
};

/**
 * AllysProjectCard - Magazine Banner Style
 * 
 * Uses the cinematic MagazineBannerCard with Allys brand colors
 * for an editorial, high-end property development presentation.
 */
export function AllysProjectCard({
  variant = 'default',
  brandColors,
  ...props
}: AllysProjectCardProps) {
  // Allys theme colors - deep navy with warm gold
  const allysColors = {
    primary: '#243462',
    accent: '#BBA339',
  };

  // Merge with any provided brand colors
  const mergedColors = {
    primary: brandColors?.primary || allysColors.primary,
    accent: brandColors?.accent || allysColors.accent,
  };

  return (
    <MagazineBannerCard
      {...props}
      brandColors={mergedColors}
      variant={variant}
    />
  );
}
